import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import { ExternalConfiguration } from '@lagoshny/ngx-hal-client';

@Injectable({
  providedIn: 'root',
})
export class ExternalConfigurationService {
  constructor(private http: HttpClient) {}

  getProxyUri(): string {
    return environment.apiUrl;
  }

  getRootUri(): string {
    return environment.apiUrl;
  }

  getHttp(): HttpClient {
    return this.http;
  }

  getExternalConfiguration(): ExternalConfiguration {
    return null;
  }

  setExternalConfiguration(externalConfiguration: ExternalConfiguration) {}

  deserialize(): any {}

  serialize(): any {}
}
